import { render, staticRenderFns } from "./card-page.vue?vue&type=template&id=402b906f"
import script from "./card-page.vue?vue&type=script&lang=js"
export * from "./card-page.vue?vue&type=script&lang=js"
import style0 from "./card-page.vue?vue&type=style&index=0&id=402b906f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports